var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resource_url)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","x-small":"","text":"","color":"blue","href":_vm.resource_url,"disabled":_vm.resource_url ? false : true,"title":"JSON for query","icon":"","target":"_blank"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("fas fa-code")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }